const JsFontSize = {
  init () {

    /*              __
                   / _)         
            .-^^^-/ /          
        __/       /              
        <__.|_|-|_|  

        The Emagine Dinosaur says; "We need to cater for everyone, some people want big fonts, some want small fonts, give them the choice.".          
    */

    // Increase/decrease font size
    $('.decrease-font-size, .increase-font-size').click(function (e) {
      e.preventDefault();
      adjustFontSize($(this));
    });

    function adjustFontSize(clickedElement) {
      var fontSize = parseInt($('html').css('font-size').slice(0, -2));
      var clickedElementClass = clickedElement.attr("class");
      if ((clickedElementClass == 'decrease-font-size') && (fontSize > 12)) {
        $('html').css('font-size', fontSize -= 2);
      } else if ((clickedElementClass == 'increase-font-size') && (fontSize < 20)) {
        $('html').css('font-size', fontSize += 2);
      }
    }


  }
};

export default JsFontSize;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/font-size.js